/* First-party article attribution. Native Google & YouTube owns purchase events. */
(function () {
  'use strict';
  var key = 'app_article_ref_v1', lifetime = 30 * 60 * 1000;
  var field = 'properties[_app_article_ref]';
  var incoming = new URLSearchParams(window.location.search).get('app_ref') || '';
  var origin = document.querySelector('[data-app-article-origin]');
  if (origin) incoming = origin.getAttribute('data-app-article-origin') || incoming;
  var accepted = false;
  function valid(value) { return /^(guide|article)_[a-z0-9_-]{1,160}$/.test(value || ''); }
  function allowed() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && p.currentVisitorConsent().analytics === 'yes');
  }
  function reference() {
    if (!allowed()) {
      try { sessionStorage.removeItem(key); } catch (e) {}
      return '';
    }
    try {
      if (!accepted && valid(incoming)) {
        sessionStorage.setItem(key, JSON.stringify({ref: incoming, expires: Date.now() + lifetime}));
        accepted = true;
      }
      var record = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (record && valid(record.ref) && record.expires > Date.now() && record.expires <= Date.now() + lifetime) return record.ref;
      sessionStorage.removeItem(key);
    } catch (e) { /* Storage restrictions must never block shopping. */ }
    return '';
  }
  function annotate(form, ref) {
    var input = form.querySelector('[data-app-article-ref]');
    if (!ref) { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = field;
      input.setAttribute('data-app-article-ref', ''); form.appendChild(input);
    }
    input.value = ref;
  }
  function refresh() {
    var ref = reference();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) { annotate(form, ref); });
  }
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) annotate(form, reference());
  }, true);
  window.addEventListener('pageshow', refresh);
  function init(attempt) {
    if (window.Shopify && window.Shopify.customerPrivacy) { refresh(); return; }
    if (attempt < 20) setTimeout(function () { init(attempt + 1); }, 250);
  }
  init(0);
})();
